export default __webpack_public_path__ + "static/media/Sean-Marjason_profile-picture.faba7cd9.jpg";